/**
 * Everything this widget says, in every language it speaks.
 *
 * The strings themselves live one file per language in `i18n/*.json`, and
 * `scripts/build-i18n.mjs` turns them into `translations.generated.ts`, which is what the code
 * imports. They travel with the library rather than living in each host's translation files, for
 * the same reason the scoped theme does: a product that imports this widget gets one that works,
 * with no setup of its own.
 *
 * Everything sits under one namespace, so nothing here can collide with what a host calls its own
 * keys. A host that wants to say something differently, most likely the assistant's name, declares
 * that one key under the same namespace: `ChatbotTranslationsService` puts these underneath the
 * host's own rather than over them.
 */
export const CHATBOT_TRANSLATION_NAMESPACE = "chatbot";

/** A string, or a group of them. The shape a translation library understands. */
export type ChatbotTranslation = string | ChatbotTranslations;

export interface ChatbotTranslations {
    [key: string]: ChatbotTranslation;
}

export { CHATBOT_TRANSLATIONS } from "./translations.generated";
